export const bookedOrderNotifierMessage = {
  success: 'Orders are booked successfully.',
  error: 'Orders booked are failed.',
};
